import * as React from 'react';
import UnpublishModal from './unpublish_modal';
import { JobAd } from '../../__models__/models';
import { shallow } from 'enzyme';
import Modal from '../general/modal/modal';
import Checkbox from '../form/checkbox/checkbox';

const jobDummy: JobAd = require('./fixtures/job_ad_dummy.json');
let wrapped;
let handleMock;

beforeAll(() => {
  handleMock = jest.fn();
  wrapped = shallow(<UnpublishModal jobAd={jobDummy} handleDone={handleMock} />);
});

test('should render correctly', () => {
  expect(wrapped.exists()).toBe(true);
});

it('it has a Modal', () => {
  expect(wrapped.find(Modal).length).toEqual(1);
});

it('it has a checkbox', () => {
  expect(wrapped.find(Checkbox).length).toEqual(1);
});

it('should have a link to close the job', () => {
  expect(wrapped.find('a').at(0).props().href).toEqual(
    `/employer/jobs/${jobDummy.attributes.slug}/close`
  );
});
